<script lang="ts">
    import Fa from 'svelte-fa'
    import { faEdit, faCreditCard, faPlusCircle, faMinusCircle, faUser, faPlug, faRobot } from '@fortawesome/free-solid-svg-icons'
    import { onMount } from 'svelte/internal'
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import Popover from '../../_common/popover.svelte'
    import { GridBadgeClassEnum, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import dayjs from 'dayjs'
    import _isToday from 'dayjs/plugin/isToday'
    import { EntryTypeEnum } from '../../../modules/financialApi/entries/entry.enum'
    import type { Entry } from '../../../modules/financialApi/entries/entry'
    import Zact from '../../_common/z/zact.svelte'
    import PaymentSelect from '../../account/payments/payment-select.svelte'
    import type { PaymentMethod } from '../../../modules/posApi/payment-methods/payment-methods'
    import Financial_4AccountsForm from '../accounts/financial-4-accounts-form.svelte'
    import PosForm from '../../pos/pos-form.svelte'

    dayjs.extend(_isToday)

    let show = false
    let entities: Entry[] = []
    let total = 0

    let paymentMethod: PaymentMethod = null

    let dates: { from: Date; to: Date } = null
    dates = window.api.utils.dates.currentMonth()

    onMount(async () => {
        await loadEntities()
    })

    function dateChanged(event) {
        dates = event.detail
        loadEntities()
    }

    async function loadEntities() {
        try {
            show = true
            total = 0
            const dt = {
                from: dates?.from || undefined,
                to: dates?.to || undefined,
                source: 'pos', // traz os registros do PDV
                paymentMethodId: !paymentMethod ? undefined : paymentMethod.paymentMethodId,
            }
            entities = await window.api.financials.entries.getAll(dt)
            entities = await window.api.utils.utils.assignPersonsFromObject(entities)
            entities = await window.api.utils.utils.assignPaymentMethodFromObject(entities)
            total = entities.reduce((total, item) => {
                total += item.value
                return total
            }, 0)
            loadGrid()
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'PDV'
        grid.subtitle = 'Movimentações financeiras previstas com base nos meios de pagamento do PDV.'
        grid.cols.push(new GridCol({ content: 'Previsão de recebimento', type: GridColTypeEnum.date }))
        grid.cols.push(new GridCol({ content: 'Lançamento', type: GridColTypeEnum.date }))
        // if (window.configs.financialShowAccrual) {
        //     grid.cols.push(new GridCol({ content: 'Competência', type: GridColTypeEnum.string }))
        // }
        grid.cols.push(new GridCol({ content: 'Meio de pagamento', type: GridColTypeEnum.string, maxLength: 30 }))
        grid.cols.push(new GridCol({ content: 'Descrição', type: GridColTypeEnum.string, maxLength: 35 }))
        grid.cols.push(new GridCol({ content: 'Pessoa', type: GridColTypeEnum.string, maxLength: 35 }))
        //grid.cols.push(new GridCol({ content: 'Categoria', type: GridColTypeEnum.string, maxLength: 40 }))
        grid.cols.push(new GridCol({ content: 'Valor', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const btnPerson = new GridButton({
                callback: () => window.person('show', item.personId),
                icon: faUser,
                label: '',
                disabled: !item.personId,
            })
            const btnOpen = new GridButton({
                callback: () => openPDV(item.invoiceId),
                icon: faCreditCard,
                label: 'PDV',
            })
            // const btnEdit = new GridButton({
            //     callback: () => goshowForm(item.entryId, item.type),
            //     icon: faEdit,
            //     label: 'Editar',
            // })
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.paymentAt })
            line.slots.push({ content: item.createdAt })
            // if (window.configs.financialShowAccrual) {
            //     line.slots.push({ content: item.accrualMonth ? `${item.accrualMonth}/${item.accrualYear}` : item.accrualYear })
            // }
            line.slots.push({ content: item.paymentMethod?.label || '-' })
            line.slots.push({ content: item.description })
            line.slots.push({ content: item.person?.name || '-' })
            //line.slots.push({ content: item.category?.label || '-' })
            line.slots.push({ content: item.type === EntryTypeEnum.credit ? item.value : item.value * -1 })
            //line.slots.push({ content: [btnEdit] })
            line.slots.push({ content: [btnOpen] })
            grid.lines.push(line)
        }
    }

    let invoiceId: string = null
    function openPDV(id: string) {
        invoiceId = id
    }

    async function closePDV() {
        show = true
        invoiceId = null

        setTimeout(async () => {
            await loadEntities()
            window.alert('Aviso: alterações feitas no PDV podem levar alguns instantes até refletirem aqui.')
        }, 3000)
    }

    let entryId = null
    let showForm = false
    let creditDebit = null
    function goshowForm(id: string, _creditDebit: EntryTypeEnum) {
        creditDebit = _creditDebit
        entryId = id
        showForm = true
    }

    function goClose(update: boolean) {
        showForm = false
        entryId = null
        if (update) loadEntities()
    }
</script>

{#if showForm}
    <Popover title="Novo lançamento" width="970px" on:close={() => goClose(true)}>
        <Financial_4AccountsForm {entryId} {creditDebit} on:change={() => goClose(true)}></Financial_4AccountsForm>
    </Popover>
{/if}

{#if invoiceId}
    <Popover title="Venda" width="1300px" height="90vh" on:close={() => (invoiceId = null)}>
        <PosForm {invoiceId} on:change={closePDV} on:cancel={() => (invoiceId = null)} />
    </Popover>
{/if}

<Content footer={true}>
    <Zact>
        <div class="fix-width">
            <PaymentSelect allowAdd={false} all={true} label="Meio de Pagamento" bind:paymentMethod on:change={loadEntities}></PaymentSelect>
        </div>
        <DateSelect startFrom={dates.from} small={true} startTo={dates.to} on:change={dateChanged} />
        <div class="spacer h-mobile" />
    </Zact>
    <Zgrid {grid} class="h-space" />
    <LoadSpinner {show} />
</Content>

<style>
    .fix-width {
        max-width: 360px;
    }
</style>
